export const environment = {
  production: false,
  apiUrl: 'https://fpisvapitest.clavisco.com/api/',
  name: 'Frutera la Paz ISV',
  env: 'Staging',
  recatchaSiteKey: '6Lcx4YAsAAAAAEsxsenxN6Nl0DzSO4sYdc_qxV_1',
  logrocket: ''
}